import { motion } from 'framer-motion'
import styled from 'styled-components'

export const StyledDateRangeSelect = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing.xs}rem;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  align-items: center;
  overflow: hidden;

  &.isCompact {
    justify-content: center;
  }

  transition: 0.2s;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.neutralGray}99;
  border: 2px solid ${({ theme }) => theme.colors.neutralGray}22;

  &.isActive {
    color: ${({ theme }) => theme.colors.neutralGray};
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.neutralGray};
    border: 2px solid ${({ theme }) => theme.colors.primary};
    background: #eeeeee10;
  }
`

export const StyledFilterLabel = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 }
})`
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1;
  min-width: 0;

  div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: initial;
    font-size: ${({ theme }) => theme.fontSize.px11}rem;
    color: ${({ theme }) => theme.dashboard.onNavyAxis};
    font-variant-numeric: tabular-nums;
  }
`

export const StyledDropdown = styled.div``

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem;
  border-radius: 100rem;

  &.isActive {
    background: ${({ theme }) => theme.colors.primary}44;

    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`

export const StyledClearIconWrapper = styled.div`
  padding: 0.4rem;
`
